const faqInit = () => {
  const faqs: NodeListOf<HTMLElement> = document.querySelectorAll(
    '.faq__wrapper',
  );
  const active: string = 'faq__answer--active';

  const closeFaqs = (clicked: HTMLElement) => {
    faqs.forEach((faq: HTMLElement) => {
      if (!(clicked === faq)) {
        const answer: HTMLElement = faq.querySelector('.faq__answer');
        answer.classList.remove(active);
      }
    });
  };

  faqs.forEach((faq: HTMLElement) => {
    const question: HTMLElement = faq.querySelector('.faq__question');
    const answer: HTMLElement = faq.querySelector('.faq__answer');

    question.addEventListener('click', (e: Event) => {
      e.preventDefault();
      e.stopPropagation();

      closeFaqs(faq);

      if (answer.classList.contains(active)) {
        answer.classList.remove(active);
      } else {
        answer.classList.add(active);
      }
    });
  });
};

export default faqInit;
